import React from 'react';

// Overlapping team avatars (24px gold-soft circles, -7px overlap, 2px white border).
// Renders a "+N" pill for any overflow beyond `max`.

interface Props {
  team: string[]; // 2-char initials, e.g. ['DB', 'PS']
  max?: number;
}

const AvatarPile = ({ team, max = 4 }: Props) => {
  // No team recorded — say so rather than render an empty pile.
  if (team.length === 0) return <span className="muted">—</span>;

  const shown = team.slice(0, max);
  const extra = team.length - shown.length;
  return (
    <div className="pile">
      {shown.map((t, i) => (
        <div key={i} className="av">
          {t}
        </div>
      ))}
      {extra > 0 && <div className="av more">+{extra}</div>}
    </div>
  );
};

export default AvatarPile;
